export default "__VITE_ASSET__eYxT8sop__"